<template>
  <main-container class="account-container" title="クレジット" :showFooter="false">
    <div slot="main-content">
      <template v-for="credit in CREDITS">
        <div class="credit-label-container"><h2>{{credit.label}}</h2></div>
        <div class="credit-item-container">
          <p class="credit-item" v-for="(item, index) in credit.items">
            <span>{{index + 1}}.</span>{{item.name}}<br>
            <span class="credit-source">出典：{{item.source}}</span>
          </p>
        </div>
      </template>
    </div>
  </main-container>
</template>

<script lang="js">
import BaseView from '../base'

export default {
  name: 'CreditView',
  mixins: [BaseView],
  computed: {
    CREDITS () {
      return [
        {
          label: '政府統計（サマリ）',
          items: [
            {
              name: '離婚数',
              source: '人口動態調査 平成21年人口動態統計 確定数 上巻 離婚　[厚生労働省]'
            }, {
              name: '婚姻数',
              source: '人口動態調査 平成21年人口動態統計 確定数 上巻 婚姻　[厚生労働省]'
            }, {
              name: '人口総数',
              source: '人口推計 平成24年10月1日現在人口推計　[総務省]'
            }, {
              name: '男性人口総数',
              source: '人口推計 平成24年10月1日現在人口推計　[総務省]'
            }, {
              name: '女性人口総数',
              source: '人口推計 平成24年10月1日現在人口推計　[総務省]'
            }, {
              name: '出生数',
              source: '人口推計 平成24年10月1日現在人口推計　[総務省]'
            }, {
              name: '死亡数',
              source: '人口推計 平成24年10月1日現在人口推計　[総務省]'
            }, {
              name: '昼間流出人口',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '昼間流入人口',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '世帯数',
              source: '平成27年国勢調査 人口等基本集計（男女・年齢・配偶関係，世帯の構成，住居の状態など）　[総務省]'
            }, {
              name: 'エネルギー消費量(燃料)',
              source: '経済産業省特定業種石油等消費統計 年報　[経済産業省]'
            }, {
              name: 'エネルギー消費量(電力)',
              source: '経済産業省特定業種石油等消費統計 年報　[経済産業省]'
            }, {
              name: '米収穫量',
              source: '作物統計調査 作況調査(水陸稲、麦類、豆類、かんしょ、飼肥料作物、工芸農作物) 確報 平成26年産作物統計（普通作物・飼料作物・工芸農作物）　[農林水産省]'
            }, {
              name: '幼稚園数',
              source: '学校基本調査 平成２７年度 初等中等教育機関・専修学校・各種学校《報告書掲載集計》 学校調査・学校通信教育調査（高等学校） 幼稚園　[文部科学省]'
            }, {
              name: '小学校数',
              source: '学校基本調査 平成２７年度 初等中等教育機関・専修学校・各種学校《報告書掲載集計》 学校調査・学校通信教育調査（高等学校） 小学校　[文部科学省]'
            }, {
              name: '中学校数',
              source: '学校基本調査 平成２７年度 初等中等教育機関・専修学校・各種学校《報告書掲載集計》 学校調査・学校通信教育調査（高等学校） 中学校　[文部科学省]'
            }, {
              name: '高等学校数',
              source: '学校基本調査 平成２７年度 初等中等教育機関・専修学校・各種学校《報告書掲載集計》 学校調査・学校通信教育調査（高等学校） 高等学校（通信教育を含む） 全日制・定時制　[文部科学省]'
            }, {
              name: '大学数',
              source: '学校基本調査 平成２７年度 高等教育機関《報告書掲載集計》 学校調査 大学・大学院　[文部科学省]'
            }, {
              name: '就業者数(総数)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(農業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(漁業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(建設業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(製造業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(情報通信業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(卸売・小売業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(金融・保険業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(不動産業)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(教育)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '就業者数(医療・福祉)',
              source: '平成27年国勢調査 速報集計 抽出速報集計　[総務省]'
            }, {
              name: '図書館数',
              source: '社会教育調査 平成２３年度 統計表 図書館調査　[文部科学省]'
            }, {
              name: '総合博物館',
              source: '社会教育調査 平成２３年度 統計表 博物館調査（博物館類似施設）　[文部科学省]'
            }, {
              name: '科学博物館',
              source: '社会教育調査 平成２３年度 統計表 博物館調査（博物館類似施設）　[文部科学省]'
            }, {
              name: '歴史博物館',
              source: '社会教育調査 平成２３年度 統計表 博物館調査（博物館類似施設）　[文部科学省]'
            }, {
              name: '美術博物館',
              source: '社会教育調査 平成２３年度 統計表 博物館調査（博物館類似施設）　[文部科学省]'
            }, {
              name: '動物園',
              source: '社会教育調査 平成２３年度 統計表 博物館調査（博物館類似施設）　[文部科学省]'
            }, {
              name: '水族館',
              source: '社会教育調査 平成２３年度 統計表 博物館調査（博物館類似施設）　[文部科学省]'
            }, {
              name: '陸上競技場',
              source: '社会教育調査 平成２３年度 統計表 体育施設調査（社会体育施設）　[文部科学省]'
            }, {
              name: '野球場・ソフトボール場',
              source: '社会教育調査 平成２３年度 統計表 体育施設調査（社会体育施設）　[文部科学省]'
            }, {
              name: '体育館',
              source: '社会教育調査 平成２３年度 統計表 体育施設調査（社会体育施設）　[文部科学省]'
            }, {
              name: '住宅数(持ち家)',
              source: '平成25年住宅・土地統計調査 確報集計　[総務省]'
            }, {
              name: '住宅数(借家)',
              source: '平成25年住宅・土地統計調査 確報集計　[総務省]'
            }, {
              name: '年間収入',
              source: '平成21年全国消費実態調査 全国 貯蓄・負債編　[総務省]'
            }, {
              name: '貯蓄',
              source: '平成21年全国消費実態調査 全国 貯蓄・負債編　[総務省]'
            }, {
              name: '負債',
              source: '平成21年全国消費実態調査 全国 貯蓄・負債編　[総務省]'
            }]
        }, {
          label: '政府統計（詳細）',
          items: [
            {
              name: '人口・世帯',
              source: `平成22年国勢調査 人口等基本集計（男女・年齢・配偶関係，世帯の構成，住居の状態など） 都道府県結果　[総務省]、平成22年市区町村別生命表の概況　[厚生労働省]`
            }, {
              name: '健康・医療',
              source: `社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '財政',
              source: `平成26年度市町村別決算状況調　[総務省]、社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '行政',
              source: `平成２６年4月1日地方公務員給与実態調査　[総務省]`
            }, {
              name: '労働',
              source: `平成２６年4月1日地方公務員給与実態調査　[総務省]、社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '外国人',
              source: `平成22年国勢調査 人口等基本集計（男女・年齢・配偶関係，世帯の構成，住居の状態など） 都道府県結果　[総務省]`
            }, {
              name: '教育',
              source: `社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '生活',
              source: `社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '福祉',
              source: `社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '経済',
              source: `社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '環境',
              source: `社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }, {
              name: '安全',
              source: `社会・人口統計体系 統計でみる市区町村のすがた2016　[総務省]`
            }]
        }, {
          label: '日銀統計',
          items: [
            {
              name: 'マーケット関連',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 マーケット関連 コールレート[月次]、為替相場（東京インターバンク相場）[月次]、実効為替レート[月次]　[日本銀行]'
            }, {
              name: '金融機関バランスシート',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 金融機関バランスシート 主要勘定 前年比（国内銀行）[月次]　[日本銀行]'
            }, {
              name: '金利',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 金利（預金・貸出関連） 基準貸付利率[月次]]、預金種類別店頭表示金利の平均年利率等[週次（月曜基準）]、貸出約定平均金利[月次]　[日本銀行]'
            }, {
              name: '国際収支',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 国際収支関連 国際収支[月次]　[日本銀行]'
            }, {
              name: '家計金融資産',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 資金循環 家計金融資産（資金循環統計）[四半期]　[日本銀行]'
            }, {
              name: '貸出',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 貸出 預金・現金・貸出金[月次]、貸出・預金動向[月次]　[日本銀行]'
            }, {
              name: '短観__年度計画',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 短観 全国短観・年度計画（経常利益）[年度]、全国短観・年度計画（設備投資額）[年度]　[日本銀行]'
            }, {
              name: '短観__DI',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 全国短観・判断項目（業況）[四半期]、全国短観・判断項目（雇用人員）[四半期]、全国短観・判断項目（国内需給）[四半期]、全国短観・判断項目（仕入価格）[四半期]、全国短観・判断項目（資金繰り）[四半期]、全国短観・判断項目（生産設備）[四半期]、全国短観・判断項目（貸出態度）[四半期]、全国短観・判断項目（販売価格）[四半期]　[日本銀行]'
            }, {
              name: '物価',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 物価 企業物価指数[月次]、企業向けサービス価格指数[月次]　[日本銀行]'
            }, {
              name: '預金・マネー',
              source: '時系列統計データ検索サイト 主要時系列統計データ表 預金・マネー マネタリーベース平均残高[月次]、マネーストック[月次]　[日本銀行]'
            }]
        }, {
          label: '地価公示',
          items: [
            {
              name: '地価公示情報',
              source: '平成２９年地価公示 [国土交通省]'
            }]
        }, {
          label: '不動産取引価格',
          items: [
            {
              name: '土地総合情報システム [国土交通省]',
              source: 'http://www.land.mlit.go.jp/webland/servlet/MainServlet'
            }]
        }, {
          label: '警察白書',
          items: [
            {
              name: '交通事故発生状況',
              source: '平成29年警察白書 統計資料 特集関連 特－３ 交通事故発生状況の推移（昭和41～平成28年）　[警察庁]'
            }, {
              name: '都道府県別の交通事故発生状況',
              source: '平成29年警察白書 統計資料 特集関連 特－４ 都道府県別の交通事故発生状況（平成28年）　[警察庁]'
            }, {
              name: '自動車運転代行業者数',
              source: '平成29年警察白書 統計資料 特集関連 特－12 都道府県別自動車運転代行業者数の推移（平成14～28年）　[警察庁]'
            }, {
              name: '運転免許保有者数(2016)',
              source: '平成29年警察白書 統計資料 特集関連 特－14 年齢層別、男女別運転免許保有者数（平成28年）　[警察庁]'
            }, {
              name: '都道府県別刑法犯(2016)',
              source: '平成29年警察白書 統計資料 第２章関連 ２－１ 都道府県別刑法犯の認知件数、検挙件数、検挙人員（平成28年）　[警察庁]'
            }, {
              name: '少年相談件数(2016)',
              source: '平成29年警察白書 統計資料 第２章関連 ２－39 警察が受理した少年相談の件数の推移（平成19～28年）　[警察庁]'
            }, {
              name: '来日外国人の国籍別検挙件数',
              source: '平成29年警察白書 統計資料 特集関連 特－　[警察庁]'
            }]
        }, {
          label: '企業情報収集',
          items: [
            {
              name: '国税庁 法人番号システムWeb-API',
              source: 'http://www.houjin-bangou.nta.go.jp/webapi/'
            }]
        }, {
          label: 'ポジネガ分析',
          items: [
            {
              name: '日本語評価極性辞書（名詞編）ver.1.0（2008年12月版）/ Japanese Sentiment Dictionary (Volume of Nouns) ver. 1.0',
              source: '東山昌彦, 乾健太郎, 松本裕治, 述語の選択選好性に着目した名詞評価極性の獲得, 言語処理学会第14回年次大会論文集, pp.584-587, 2008. / Masahiko Higashiyama, Kentaro Inui, Yuji Matsumoto. Learning Sentiment of Nouns from Selectional Preferences of Verbs and Adjectives, Proceedings of the 14th Annual Meeting of the Association for Natural Language Processing, pp.584-587, 2008.'
            }]
        }]
    }
  }
}

</script>

<style scoped>
  .credit-label-container {
    padding: 25px 40px;
    background: #fff;
  }

  .credit-label-container > h2 {
    font-size: 1.5rem;
    font-weight: normal;
    padding: 0;
  }

  .credit-item-container {
    padding: 25px 40px;
    background: #f1f5f8;
    border-bottom: 1px solid #c0d5ef;
  }

  .credit-item {
    margin: 0 0 10px 0;
  }

  .credit-item > .credit-source {
    font-size: 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/credit/credit.vue